import '../location/agenda.css'

const agenda = [
    { time: "17.30", title: "Welcoming Dinner", desc: "Penyambutan tamu undangan" },
    { time: "18.30", title: "Opening Ceremonial", desc: "Sambutan & doa pembuka" },
    { time: "19.30", title: "Awarding Night", desc: "Penyerahan penghargaan kepada mitra, alumni & siswa berprestasi" },
    { time: "20.00", title: "Motivational Speech & Talkshow", desc: "Inspirasi & wawasan baru dari alumni sukses dan tokoh pendidikan" },
    { time: "21.00", title: "Closing & Foto Bersama", desc: "Penutupan acara & foto bersama" },
];

const Agenda = () => {

    return (
        <section id="agenda">
            <div className="container">
                <section className="agenda-section">
                    <div className="agenda-container">
                        <div className="agenda-header">
                            <p className="display-title">Rangkaian Acara</p>
                            <h2 className="agenda-title display-header">
                                Susunan <span className="display-gold">Agenda</span>
                            </h2>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <ul className="agenda-timeline">
                                {agenda.map((a, i) => (
                                    <li key={i} className="agenda-item">
                                        <span className="agenda-dot" />

                                        <div className="agenda-content">
                                            <span className="agenda-time">{a.time}</span>
                                            <div>
                                                <h3 className="agenda-item-title">{a.title}</h3>
                                                <p className="agenda-item-desc">{a.desc}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    )
}

export default Agenda